import { Crown } from "lucide-react";
import { KnotDivider, FrameCorners } from "@/components/ornaments";
import { useSite } from "@/context/SiteContext";

export default function VaultPage() {
  const { settings } = useSite();
  return (
    <div data-testid="vault-page" className="max-w-4xl mx-auto px-6 py-20">
      <div className="relative vellum gilt p-12 text-center theme-flame">
        <FrameCorners />
        <Crown className="w-12 h-12 mx-auto text-[#991b1b]" />
        <p className="eyebrow mt-6">The Royal Vault</p>
        <h1 data-testid="vault-title" className="font-display text-4xl sm:text-5xl mt-2">{settings.vault_title || "Treasures Yet to Come"}</h1>
        <KnotDivider className="my-8" />
        <p data-testid="vault-message" className="text-lg italic text-[#4a3a2a] whitespace-pre-line">{settings.vault_message || "Maps, sigil banners, and keepsakes of Elirios will one day be offered here. The vault doors remain sealed — for now."}</p>
      </div>
    </div>
  );
}
